import { useParams } from "react-router-dom";
import StaffPortalInstallGate from "@/components/mobile/StaffPortalInstallGate";

export default function ProductionDashboardRedirect() {
  const { code } = useParams();
  if (!code) return null;

  return (
    <StaffPortalInstallGate
      kind="kitchen"
      code={code}
      shortHomePath={`/pp/${encodeURIComponent(code)}`}
      fetchPath={`/api/pp/${encodeURIComponent(code)}${window.location.search || ""}`}
    />
  );
}
